import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AlertComponent, BtnComponent, BtnGroupComponent, CheckboxComponent, ConfirmDialogComponent, DefaultPlayerComponent, GenericHeadingComponent,
  GenericMultiSelectComponent,
  GenericSelectTreeComponent,
  GenericTabComponent, InputComponent, LoaderComponent, MiniBtnComponent, NotificationsBadgeComponent, PaginationComponent, PasswordComponent,
  RadioComponent, SearchInputTextComponent, SearchResultListComponent, SelectComponent, SmallPaginationComponent, StepsPanelComponent } from './components';
import { OnlyNumberDirective, SortableHeaderDirective, TaVerticalResizeDirective, TooltipDirective } from './directives';
import { LoaderBarComponent } from './components/loader-bar/loader-bar.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularResizeEventModule } from 'angular-resize-event';
import { OrderByPipe } from './pipes/order-by.pipe';
import { SimplePaginationComponent } from './components/simple-pagination/simple-pagination.component';
import { RadioInputComponent } from './components/inputs/radio-input/radio-input.component';
import { SearchInputComponent } from './components/inputs/search-input/search-input.component';


@NgModule({
  declarations: [
    AlertComponent,
    BtnComponent,
    BtnGroupComponent,
    ConfirmDialogComponent,
    CheckboxComponent,
    DefaultPlayerComponent,
    GenericHeadingComponent,
    GenericMultiSelectComponent,
    GenericSelectTreeComponent,
    GenericTabComponent,
    InputComponent,
    LoaderComponent,
    LoaderBarComponent,
    MiniBtnComponent,
    NotificationsBadgeComponent,
    OnlyNumberDirective,
    OrderByPipe,
    PaginationComponent,
    PasswordComponent,
    RadioComponent,
    SearchInputTextComponent,
    SearchResultListComponent,
    SelectComponent,
    SmallPaginationComponent,
    SortableHeaderDirective,
    TaVerticalResizeDirective,
    TooltipDirective,
    SimplePaginationComponent,
    StepsPanelComponent,
    RadioInputComponent,
    SearchInputComponent
  ],
  imports: [
    AngularResizeEventModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // NgbModule,
    NgbModalModule
  ],
  exports: [
    AlertComponent,
    BtnComponent,
    BtnGroupComponent,
    ConfirmDialogComponent,
    CheckboxComponent,
    DefaultPlayerComponent,
    GenericHeadingComponent,
    GenericMultiSelectComponent,
    GenericSelectTreeComponent,
    GenericTabComponent,
    InputComponent,
    LoaderComponent,
    LoaderBarComponent,
    MiniBtnComponent,
    NotificationsBadgeComponent,
    OnlyNumberDirective,
    OrderByPipe,
    PaginationComponent,
    PasswordComponent,
    RadioComponent,
    RadioInputComponent,
    SearchInputComponent,
    SearchInputTextComponent,
    SearchResultListComponent,
    SelectComponent,
    SimplePaginationComponent,
    SmallPaginationComponent,
    SortableHeaderDirective,
    StepsPanelComponent,
    TaVerticalResizeDirective,
    TooltipDirective
  ]
})
export class UiLibModule { }
